import {autoEquTableColumnLabels} from "@/features/i18n/autoEquTableColumns";

export interface AutoEquTableInterface {
    f_equ_c_typ: string;
    f_equ_veh_desc_n: string;
    f_equ_pri_xls_desc_n: string;
    f_equ_pri_xls_dealer_net_mnt: number | null;
    f_equ_pri_xls_retail_net_mnt: number | null;
}

export type AutoEquDataColumn = {
    accessorKey: keyof AutoEquTableInterface;
    header: string;
    size?: number;
};

export const autoEquColumns: AutoEquDataColumn[] = [
    {accessorKey: "f_equ_c_typ", header: autoEquTableColumnLabels.f_equ_c_typ, size: 90},
    {accessorKey: "f_equ_veh_desc_n", header: autoEquTableColumnLabels.f_equ_veh_desc_n, size: 240},
    {accessorKey: "f_equ_pri_xls_desc_n", header: autoEquTableColumnLabels.f_equ_pri_xls_desc_n, size: 280},
    {accessorKey: "f_equ_pri_xls_dealer_net_mnt", header: autoEquTableColumnLabels.f_equ_pri_xls_dealer_net_mnt, size: 160},
    {accessorKey: "f_equ_pri_xls_retail_net_mnt", header: autoEquTableColumnLabels.f_equ_pri_xls_retail_net_mnt, size: 160},
];

